import { ActionContext, ActionTree } from 'vuex';
import {
  SET_NONPROFIT_LIST,
  SET_TOTAL_NONPROFITS_BY_QUERY,
  SET_SELECTED_CAUSES, SET_TEMPLATE,
  UPDATE_NONPROFIT_LIST,
  SET_QUERY_NUMBER,
  SET_REMOTE_FRIENDLY,
  SET_MEMBER_METROPOLITAN_AREAS,
  SET_OPEN_OPPORTUNITIES,
  SET_KEYWORDS,
  SET_EVENT_TYPES,
  SET_FUNNEL_TYPES

} from './mutation-types';
import State from './state';
import RootState from '../../state'
import searchAndDiscoveryService from '../../../services/searchAndDiscoveryService';
import nonprofitProfileService from '../../../services/nonprofitProfileService'
import camelizer from '../../../../../../services/convertDataStrategies/classes/camelizer';
import { ISearchFilter } from "../../../models/interfaces/searchAndDiscovery/iSearchFilter";
import { IDiscoveryFilter } from "../../../models/interfaces/searchAndDiscovery/iDiscoveryFilter";
import { ICause } from "../../../models/interfaces/iCause";
import { ISearchFilterSettings } from "../../../models/interfaces/searchAndDiscovery/iSearchFilterSettings";
import { ISetFavoritesResponse } from "../../../models/interfaces/iSetFavoritesResponse";
import { Fan } from "../../../models/classes/fan";
import { IFan } from "../../../models/interfaces/iFan";
import { ISearchAndDiscovery } from "../../../models/interfaces/searchAndDiscovery/iSearchAndDiscovery";
import { DiscoveryFilter } from '../../../models/classes/searchAndDiscovery/discoveryFilter';
import { IKeyName } from '../../../models/interfaces/IKeyName';
import { IMetropolitanArea } from '../../../models/interfaces/iMetropolitanArea';

// ActionTree<[current state], [root state]>
const actions: ActionTree<State, RootState> = {

  getNonprofitsBySearchFilter({ commit, state }: ActionContext<State, RootState>, searchFilterSettings: ISearchFilterSettings): Promise<any> {
    //debugger;
    return new Promise((resolve, reject) => {
      searchAndDiscoveryService.getNonprofitsBySearchFilter(searchFilterSettings.searchFilter).then((rsp: any) => {
        let camilizedResponse: any = camelizer.convert(rsp);

        if (searchFilterSettings.toUpdateVuexStorage) {
          if (!camilizedResponse.data) {
            commit(SET_TOTAL_NONPROFITS_BY_QUERY, 0);
            commit(SET_NONPROFIT_LIST, []);
          }
          else {
            let searchAndDiscoveryProfile: ISearchAndDiscovery = camilizedResponse.data;
            //debugger;
            if (state.profile.queryNumber < +searchAndDiscoveryProfile.queryNumber) {
              commit(SET_QUERY_NUMBER, searchAndDiscoveryProfile.queryNumber);
              commit(SET_TOTAL_NONPROFITS_BY_QUERY, searchAndDiscoveryProfile.totalNonprofitsByQuery);
              commit(SET_NONPROFIT_LIST, searchAndDiscoveryProfile.nonprofits);
            }
          }
        }

        resolve(camilizedResponse)
      })
        .catch((error: any) => reject(error));
    })
  },

  getNonprofitsByDiscoveryFilter({ commit, state }: ActionContext<State, RootState>, discoveryFilter: IDiscoveryFilter): Promise<any> {

    return new Promise((resolve, reject) => {
      searchAndDiscoveryService.getNonprofitsByDiscoveryFilter(discoveryFilter).then((rsp: any) => {
        let camilizedResponse: any = camelizer.convert(rsp);

        //debugger;
        if (!camilizedResponse.data) {
          commit(SET_TOTAL_NONPROFITS_BY_QUERY, 0);
          commit(SET_NONPROFIT_LIST, []);
        }
        else {
          let searchAndDiscoveryProfile: ISearchAndDiscovery = camilizedResponse.data;
          //debugger;
          if (state.profile.queryNumber < +searchAndDiscoveryProfile.queryNumber) {
            commit(SET_QUERY_NUMBER, searchAndDiscoveryProfile.queryNumber);
            commit(SET_TOTAL_NONPROFITS_BY_QUERY, searchAndDiscoveryProfile.totalNonprofitsByQuery);
            commit(SET_NONPROFIT_LIST, searchAndDiscoveryProfile.nonprofits);
          }
        }

        resolve(camilizedResponse)
      })
        .catch((error: any) => reject(error));
    })
  },

  async getMoreNonprofitsBySearchFilter({ commit }: ActionContext<State, RootState>, searchFilterSettings: ISearchFilterSettings): Promise<any> {
    const result = await searchAndDiscoveryService.getNonprofitsBySearchFilter(searchFilterSettings.searchFilter);
    const camilizedResponse: any = camelizer.convert(result);

    commit(UPDATE_NONPROFIT_LIST, camilizedResponse.data.nonprofits);

    return camilizedResponse;
  },

  async getMoreNonprofitsByDiscoveryFilter({ commit }: ActionContext<State, RootState>, discoveryFilter: IDiscoveryFilter): Promise<any> {
    const result = await searchAndDiscoveryService.getNonprofitsByDiscoveryFilter(discoveryFilter);
    const camilizedResponse: any = camelizer.convert(result);

    commit(UPDATE_NONPROFIT_LIST, camilizedResponse.data.nonprofits);

    return camilizedResponse;
  },

  setSelectedCauses({ commit, state }: ActionContext<State, RootState>, selectedCauses: ICause[]): Promise<any> {

    return new Promise((resolve, reject) => {

      commit(SET_SELECTED_CAUSES, selectedCauses);
      resolve(true);
    })
  },

  setTemplate({ commit, state }: ActionContext<State, RootState>, template: string): Promise<any> {

    return new Promise((resolve, reject) => {

      commit(SET_TEMPLATE, template);
      resolve(true);
    })
  },

  setKeywords({ commit, state }: ActionContext<State, RootState>, keywords: string[]): Promise<any> {

    return new Promise((resolve, reject) => {

      commit(SET_KEYWORDS, keywords);
      resolve(true);
    })
  },

  setRemotefriedly({ commit, state }: ActionContext<State, RootState>, remoteFriendly: IKeyName[]): Promise<any> {

    return new Promise((resolve, reject) => {

      commit(SET_REMOTE_FRIENDLY, remoteFriendly);
      resolve(true);
    })
  },

  setMemberMetropolitanAreas({ commit, state }: ActionContext<State, RootState>, metropolitanAreas: IMetropolitanArea[]): Promise<any> {

    return new Promise((resolve, reject) => {

      commit(SET_MEMBER_METROPOLITAN_AREAS, metropolitanAreas);
      resolve(true);
    })
  },

  setOpenOpportunities({ commit, state }: ActionContext<State, RootState>, openOpportunities: IKeyName[]): Promise<any> {

    return new Promise((resolve, reject) => {

      commit(SET_OPEN_OPPORTUNITIES, openOpportunities);
      resolve(true);
    })
  },
  setEventTypes({ commit, state }: ActionContext<State, RootState>, eventTypes: IKeyName[]): Promise<any> {

    return new Promise((resolve, reject) => {

      commit(SET_EVENT_TYPES, eventTypes);
      resolve(true);
    })
  },
  setPrefTypes({ commit, state }: ActionContext<State, RootState>, prefTypes: IKeyName[]): Promise<any> {

    return new Promise((resolve, reject) => {

      commit(SET_FUNNEL_TYPES, prefTypes);
      resolve(true);
    })
  },
  
  setQueryNumber({ commit, state }: ActionContext<State, RootState>, queryNumber: number): Promise<any> {

    return new Promise((resolve, reject) => {

      commit(SET_QUERY_NUMBER, queryNumber);
      resolve(true);
    })
  },

  setDiscoveryFilter({ commit, state }: ActionContext<State, RootState>, filter: DiscoveryFilter): Promise<any> {

    return new Promise((resolve, reject) => {

      commit(SET_QUERY_NUMBER, filter);
      resolve(true);
    })
  },

  setFavorites({ commit }: ActionContext<State, RootState>, orgKey: string): Promise<any> {
    return new Promise((resolve, reject) => {
      nonprofitProfileService.setFavorites(orgKey)
        .then((res: any) => {
          const data = <ISetFavoritesResponse>camelizer.convert(res.data);
          const fan: IFan = new Fan({ isFan: data.isFan, orgKey: data.orgKey });
          resolve(fan);
        })
        .catch((error: any) => reject(error));
    });
  },
};

export default actions;



// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/searchAndDiscovery/actions.ts